<script setup lang="ts">
/*
 * FILE: unified_ui/src/components/LoadingScreen.vue
 * PURPOSE: Blank loading state shown while the identity store determines whether
 *          the user is authenticated or should see the access gate. Prevents a
 *          flash of the app shell on initial load.
 */
</script>

<template>
  <div class="flex h-screen w-full items-center justify-center bg-slate-50">
    <div class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-brand-500" />
  </div>
</template>
